import React from 'react';
import { Link } from 'react-router-dom';

const CTA = () => {
    return (
        <div>
            <section class=" py-9 dark:bg-gray-900 border-t border-b">
                <div class="max-w-6xl flex flex-col items-center px-5 xl:px-0 py-12 mx-auto text-center">
                    <h2 class="text-3xl font-bold tracking-tight text-gray-800 xl:text-4xl dark:text-white">
                        Try something really different right now.
                    </h2>

                    <p class="block max-w-4xl mt-4 text-gray-500 dark:text-gray-300">
                        Lorem, ipsum dolor sit amet consectetur
                        adipisicing elit. Esse iure tenetur commodi ipsam error voluptate magni. Adipisci repudiandae ullam commodi
                        iusto reprehenderit suscipit facere voluptatem, eaque maiores minima. Neque, officiis.
                    </p>

                    <div class="mt-6">
                        <Link to='/allcourse' class="inline-flex items-center justify-center w-full px-5 py-4 overflow-hidden text-white transition-colors duration-300 bg-blue-900 rounded shadow sm:w-auto sm:mx-2 hover:bg-blue-800 dark:bg-gray-800 dark:hover:bg-blue-800 focus:ring focus:ring-gray-300 focus:ring-opacity-80">
                            <span class="mx-2 uppercase">
                                Get Started Now
                            </span>
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CTA;